<div class="text-center session-timer fs-14 d-flex align-items-center justify-content-center">
    <p class="session-timer__text mb-0 fw_400 mr_7 d-flex align-items-center"><i class="icon icon-clock me-2"></i>Session expires in:</p>
    <p class="session-timer__timer">
        {{ (timeRemaining | async | date: 'mm:ss') ?? '&#8203;' }}m
    </p>
</div>
